export default "__VITE_ASSET__CiV$drUI__"